import { useState } from "react";
import BreadCrumb from "../../../Components/BreadCrumb";
import WebsiteSettings from "./WebsiteSettings";
import ContactSettings from "./ContactSettings";
import PageMetaSettings from "./PageMetaSettings";
import SmtpSettings from "./SmtpSettings";
import SocialLinksSettings from "./SocialLinksSettings";
import PageContentSettings from "./PageContentSettings";

const TABS = [
  { key: "website", label: "Website Settings" },
  { key: "contact", label: "Contact Page Settings" },
  { key: "meta",    label: "Page Meta Information" },
  { key: "smtp",    label: "SMTP Settings" },
  { key: "social",  label: "Social Links" },
  { key: "content", label: "Page Content" },
];

const Settings = () => {
  const [active, setActive] = useState("website");

  return (
    <div className="p-4">
      <BreadCrumb title="Settings" />

      <div className="mt-4">
        <div className="flex gap-1 border-b border-gray-200 dark:border-slate-700 mb-6 overflow-x-auto">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 transition-colors focus:outline-none
                ${active === tab.key
                  ? "border-orange-500 text-orange-600 dark:text-orange-400"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-slate-500"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {active === "website" && <WebsiteSettings />}
        {active === "contact" && <ContactSettings />}
        {active === "meta"    && <PageMetaSettings />}
        {active === "smtp"    && <SmtpSettings />}
        {active === "social"  && <SocialLinksSettings />}
        {active === "content" && <PageContentSettings />}
      </div>
    </div>
  );
};

export default Settings;
